import React from "react";
import { useEffect, useState } from "react";
import DocumentTitle from "react-document-title";
import Auth from "../../Auth/Auth";
import SavingsPlanService from "../../services/SavingsPlanService";
import ActiveSavingPlans from "../SavePlans/ActiveSavingPlans";
import SavingsPlansConfiguring from "./SavingsPlansConfiguring";
import RelationPlans from "../SavePlans/RelationPlans";
import ExpiredSavingPlans from "../SavePlans/ExpiredSavingPlans";
import CancelledSavingPlans from "../SavePlans/CancelledSavingPlans";
import { ITableSPlansRelational } from "../SavePlans/TableRelationPlans";
import { Spinner, SpinnerSize } from "@fluentui/react";
import { ITableSPlansActive } from "../SavePlans/types/SavePlansTypes";
import { RootStateOrAny, useSelector } from "react-redux";

const SavingsPlans = () =>
{
    const [savingsPlans, setSavingsPlans] = useState<ITableSPlansActive[]>();
    const [relationalPlans, setRelationalPlans] = useState<ITableSPlansRelational[]>();
    const [configuringSavingsPlans, setConfiguringSavingsPlans] = useState<ITableSPlansActive[]>();
    const [activeSavingsPlans, setActiveSavingsPlans] = useState<ITableSPlansActive[]>();
    const [expiredSavingsPlans, setExpiredSavingsPlans] = useState<ITableSPlansActive[]>();
    const [canceledSavingsPlans, setCanceledSavingsPlans] = useState<ITableSPlansActive[]>();
    const [error, setError] = useState({message: false});
    const [loading, setLoading] = useState<boolean>(true);
    const [refreshTable, setRefreshTable] = useState<boolean>(false);
    const activePlan = useSelector((state: RootStateOrAny) => state.auth.userActivePlan);
    const user = Auth.getUserProfile();

    useEffect(() =>
    {
        setRefreshTable(true);
    }, []);

    useEffect(() =>
    {
        if(refreshTable)
        {
            setLoading(true);
            setRefreshTable(false);
            Promise.all([SavingsPlanService.getSavingsPlansAndStatus(user.id), SavingsPlanService.getRelationalPlans(user.id)]).then(([plans, relationalPlans]) =>
            {
                setSavingsPlans(plans.sort((a, b) =>
                {
                    return a.startDate.split("-").reverse().join("-").localeCompare(b.startDate.split("-").reverse().join("-"));
                }));
                setRelationalPlans(relationalPlans);
            })
            .catch((error) =>
            {
                setError(error);
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refreshTable]);

    useEffect(() =>
    {
        if(savingsPlans !== undefined)
        {
            const configuringSavingsPlans = savingsPlans.filter((sP) => sP.status < 4);
            setConfiguringSavingsPlans(configuringSavingsPlans);

            const activeSavingsPlans = savingsPlans.filter((sP) => sP.status === 4);
            setActiveSavingsPlans(activeSavingsPlans);

            const expiredSavingsPlans = savingsPlans.filter((sP) => sP.status === 5);
            setExpiredSavingsPlans(expiredSavingsPlans);

            const canceledSavingsPlans = savingsPlans.filter((sP) => sP.status === 6);
            setCanceledSavingsPlans(canceledSavingsPlans);

            setLoading(false);
        }
    }, [savingsPlans]);

    return(
        <DocumentTitle title="IronIA - Mis Planes de Cartera">
            <React.Fragment>
                <div className="ms-Grid-row savings-plans">
                    <h2 style={{cursor: "default"}}>Mis Planes de Cartera</h2>
                    <p className="description">
                        Ten a mano todos los detalles sobre tus planes de cartera y configura o edita las cosas que necesites...
                    </p>
                </div>
                {loading && <Spinner size={SpinnerSize.large} />}
                {!loading &&
                (
                    <React.Fragment>
                        {expiredSavingsPlans !== undefined && expiredSavingsPlans.length > 0 &&
                        (
                            <ExpiredSavingPlans
                                data={expiredSavingsPlans}
                                loading={loading}
                                activePlan={activePlan}
                                error={error}
                            />
                        )}
                        {activeSavingsPlans !== undefined && activeSavingsPlans.length > 0 &&
                        (
                            <ActiveSavingPlans
                                data={activeSavingsPlans}
                                loading={loading}
                                activePlan={activePlan}
                                error={error}
                            />
                        )}
                        {configuringSavingsPlans !== undefined && configuringSavingsPlans.length > 0 &&
                        (
                            <SavingsPlansConfiguring
                                data={configuringSavingsPlans}
                                loading={loading}
                                error={error}
                                reload={(reloadData) =>
                                {
                                    if(reloadData)
                                    {
                                        setRefreshTable(true);
                                    }
                                }}
                            />
                        )}
                        {relationalPlans !== undefined && relationalPlans.length > 0 &&
                        (
                            <RelationPlans data={relationalPlans} loading={loading} error={error} />
                        )}
                        {canceledSavingsPlans !== undefined && canceledSavingsPlans.length > 0 &&
                        (
                            <CancelledSavingPlans
                                data={canceledSavingsPlans}
                                loading={loading}
                                activePlan={activePlan}
                                error={error}
                            />
                        )}
                    </React.Fragment>
                )}
            </React.Fragment>
        </DocumentTitle>
    );
};

export default SavingsPlans;